import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import CheckboxComponent from '#app/Component/CheckboxComponent';
import MultipleSelectComponent from '#app/Component/MultipleSelectComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { Filters } from '#app/View/InventoryManagement/Inventory/DepositInventory/hooks/useInventory';
import useMarks from '#app/View/InventoryManagement/Inventory/DepositInventory/hooks/useMarks';

type Props = {
  handleSearch: (data: Filters) => void;
  filters: Partial<Filters>;
};

const Search: React.FC<Props> = ({ handleSearch, filters }) => {
  const { marks } = useMarks();
  const classes = useStyles();

  const [formSearch, setFormSearch] = useState<Form>({
    marks: {
      name: 'marks',
      label: 'Marques',
      textHelper: 'Rechercher par marque.',
      type: 'array',
      defaultValue: filters?.marks,
    },
    withStock: {
      name: 'withStock',
      label: 'En stock uniquement',
      type: 'boolean',
      defaultValue: (filters.withStock as unknown as string) === 'true',
    },
  });
  const handlerForm = initFormHandler(formSearch, setFormSearch);
  useEffect(() => {
    handlerForm.start();
  }, []);

  useEffect(() => {
    handlerForm.setValue('withStock', filters.withStock ? true : (filters.withStock as unknown as string) === 'true');
  }, [filters]);

  const getData = (): Filters => {
    const data = handlerForm.getData();
    return {
      marks: data.marks,
      withStock: data.withStock,
    };
  };

  return (
    <ShadowBoxComponent className={classes.container} id="search-inventory">
      <Grid container>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent
            withSelectAll
            id="marks"
            options={marks.map(({ id, label }) => ({ value: id, label }))}
            handler={handlerForm}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <CheckboxComponent id="withStock" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <ButtonComponent className={classes.button} label="Rechercher" onClick={() => handleSearch(getData())} />
        </Grid>
      </Grid>
    </ShadowBoxComponent>
  );
};

const useStyles = makeStyles({
  container: {
    marginBottom: 20,
    scrollMarginTop: '70px',
  },
  button: {
    margin: '6px !important',
  },
});

export default Search;
